// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-76ae74de] .v-skeleton-loader__actions{text-align:left;padding:6px 0 18px}.sort-option-select[data-v-76ae74de]{width:200px;max-width:200px}.search-field[data-v-76ae74de]{width:225px;max-width:225px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
